import React, {useContext, useRef, useState, useEffect} from "react";
import Row from "@meridian/components/row";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../../util/RefreshTimer";
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Button from "react-bootstrap/Button";
import AddTrafficLightDeviceModal from "./modal/AddTrafficLightDeviceModal";
import {PermissionsContext} from "../../permissions/PermissionsContext";
import {TrafficLightDeviceOverviewContext} from "./context/TrafficLightOverviewContext";
import UpdateDeviceDetailsResponse from "./modal/UpdateDeviceDetailsResponse";

const TrafficLightControlPage = ({controllerDetails, indexForControllerData}) => {
    const {viewModel, dispatch} = useContext(TrafficLightDeviceOverviewContext);
    const [controllerConfig, setControllerConfig] = useState(controllerDetails);
    const tableEndRef = useRef(null)
    const [openAddNewDeviceModal, setOpenAddNewDeviceModal] = useState(false)
    const {isManager} = useContext(PermissionsContext);
    const [sortColumn, setSortColumn] = useState('name');
    const [sortDirection, setSortDirection] = useState('ascending')

    useEffect(() =>  {
        setControllerConfig(controllerDetails)
    }, [controllerDetails.assetMappings])

    const updateDeviceStatus = (newStatus, index) => {
        let updatedTrafficLightAssetDetails = {...controllerConfig}
        updatedTrafficLightAssetDetails["assetMappings"][index]["mappingAttributes"]["color"] =
            (updatedTrafficLightAssetDetails["assetMappings"][index]["mappingAttributes"]["color"] === newStatus ? null: newStatus);
        dispatch({type: 'UPDATE_TRAFFIC_LIGHT_SIGNAL_DATA', data: {dispatcher: dispatch, controllerDataIndex: indexForControllerData, trafficLightDataIndex: index, assetDetails: updatedTrafficLightAssetDetails}});
        setControllerConfig(updatedTrafficLightAssetDetails);
    }

    const deleteDevice = (index) => {
        let updatedTrafficLightAssetDetails = {...controllerConfig}
        updatedTrafficLightAssetDetails["assetMappings"].splice(index, 1)
        dispatch({type: 'UPDATE_TRAFFIC_LIGHT_DEVICE_DATA', data: {dispatcher: dispatch, index: indexForControllerData, assetDetails: updatedTrafficLightAssetDetails}});
        setControllerConfig(updatedTrafficLightAssetDetails)
    }

    const onSort = (sortDetails) => {
        const sortedDeviceList = {...controllerDetails};
        sortedDeviceList && sortedDeviceList.assetMappings.sort((a, b) => {
            if (a[sortDetails.sortColumn] < b[sortDetails.sortColumn]) {
                return sortDetails.sortDirection === "ascending" ? -1 : 1
            }
            if (a[sortDetails.sortColumn] > b[sortDetails.sortColumn]) {
                return sortDetails.sortDirection === "ascending" ? 1 : -1
            }
            return 0
        })

        setSortColumn(sortDetails.sortColumn);
        setSortDirection(sortDetails.sortDirection);
        setControllerConfig(sortedDeviceList)
    }

        return (
            controllerConfig.assetMappings ? <Row widths="100%" alignmentVertical="top" spacingInset="none none large none">
                <Column>
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <RefreshTimer deps={[viewModel]}/>
                    </Row>
                    {
                        controllerConfig.assetMappings.length === 0 ?
                            <Alert type="informational" size="small">
                                <FormattedMessage id="alert.device" defaultMessage="No device present for this station."/>
                            </Alert> :
                            <Table
                                headerRows={1}
                                spacing="small"
                                showDividers={true}
                                showStripes={true}
                                sortColumn={sortColumn}
                                onSort={onSort}
                                sortDirection={sortDirection}
                            >
                                <TableRow highlightOnHover={false}>
                                    <TableCell sortColumn="mappedResourceLabel">
                                        <FormattedMessage id="device.name" defaultMessage="Name"/>
                                    </TableCell>
                                    <TableCell>
                                        <FormattedMessage id="device.wave" defaultMessage="Wave"/>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                                {controllerConfig.assetMappings.map((device, index) => (
                                    <TableRow key={index} highlightOnHover={true}>
                                        <TableCell>
                                            <b>{device.mappedResourceLabel}</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>{device.mappingAttributes.wave}</b>
                                        </TableCell>
                                        <TableCell>
                                            <Row>
                                                <Button
                                                    variant={device.mappingAttributes.color === "RED" ? 'danger' : "outline-danger"}
                                                    onClick={() => updateDeviceStatus("RED", index)}
                                                    disabled={!isManager}
                                                >
                                                    Red
                                                </Button>
                                                <Button
                                                    variant={device.mappingAttributes.color === "GREEN" ? 'success' : "outline-success"}
                                                    onClick={() => updateDeviceStatus("GREEN", index)}
                                                    disabled={!isManager}
                                                >
                                                    Green
                                                </Button>
                                                <Button
                                                    variant={device.mappingAttributes.color === "YELLOW" ? 'warning' : "outline-warning"}
                                                    onClick={() => updateDeviceStatus("YELLOW", index)}
                                                    disabled={!isManager}
                                                >
                                                    Yellow
                                                </Button>
                                            </Row>
                                        </TableCell>
                                        <TableCell>
                                            <Button variant="danger" size="small" onClick={() => deleteDevice(index)} disabled={!isManager}>Delete Device</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </Table>
                    }
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <Button variant="info" size="small" onClick={() => setOpenAddNewDeviceModal(true)} disabled={!isManager}>
                            <FormattedMessage id="device.add_device_button_modal" defaultMessage="Add Device Configuration"/>
                        </Button>
                    </Row>
                    <AddTrafficLightDeviceModal open={openAddNewDeviceModal} setOpen={setOpenAddNewDeviceModal} controllerConfig={controllerConfig}
                                                indexForControllerData={indexForControllerData}/>
                    <UpdateDeviceDetailsResponse/>
                    <div ref={tableEndRef}/>
                </Column>
            </Row> : null
        )
}

export default TrafficLightControlPage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/TrafficLightControlPage.js